export const AUTH_CODE_SUCCESSFUL = "auth_code_successful";
export const AUTH_CODE_FAILED = "auth_code_failed"